import React, { useCallback } from "react";
import { MenuBookRounded } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { useNavigate, useLocation } from "react-router-dom";
import SidebarNavItem from "./SidebarNavItem";

// Otvorí podstránku s príručkou (text + grafické zobrazenie procesov)
// namiesto sťahovania PDF. PDF je naďalej dostupné na samotnej stránke.
const DownloadManualItem = ({ open }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const handleOpenManual = useCallback(() => {
    navigate("/manual");
  }, [navigate]);

  return (
    <SidebarNavItem
      open={open}
      icon={<MenuBookRounded />}
      text={t("sidebar.items.manual", "Príručka / Manuál")}
      active={pathname === "/manual"}
      onClick={handleOpenManual}
    />
  );
};

export default DownloadManualItem;
